import http from "@/settings/apiSettings"

class ProComenziDataService {
    getCategoriiComenzi(): Promise<any> {
        return http.clientComercialOdata.get("PRO_CategoriiComenzi");
    }

    getComenziFiltrate(filter: any): Promise<any> {
        return http.clientComercialOdata.get("PRO_Comenzi", filter);
    }

    creeazaComanda(data: { Tipcomanda?: number | null; [key: string]: any }): Promise<any> {
        return http.clientComercialOdata.post("PRO_Comenzi", data);
    }

    adaugaLinie(data: { ComandaID: string; [key: string]: any }): Promise<any> {
        return http.clientComercialOdata.post("PRO_ComenziDetalii", data);
    }

    getAgentCurent(): Promise<any> {
        return http.clientComercial.get('PRO_Comenzi/agent-curent');
    }

    schimbaStare(comandaId: string, stareNoua: string, motiv?: string): Promise<any> {
        return http.clientComercial.post(`PRO_Comenzi/${comandaId}/stare`, { StareNoua: stareNoua, Motiv: motiv ?? null });
    }

    patchComanda(id: string, data: Record<string, any>): Promise<any> {
        return http.clientComercialOdata.patch(`PRO_Comenzi(${id})`, data);
    }

    patchLinie(id: string, data: Record<string, any>): Promise<any> {
        return http.clientComercialOdata.patch(`PRO_ComenziDetalii(${id})`, data);
    }

    stergeLinie(id: string): Promise<any> {
        return http.clientComercialOdata.delete(`PRO_ComenziDetalii(${id})`);
    }

    getCantitatiRezervate(comandaId: string): Promise<any> {
        return http.clientComercial.get(`PRO_Rezervari/${comandaId}/cantitati`);
    }

    getStocuriProduse(comandaId: string): Promise<any> {
        return http.clientComercial.get(`PRO_Rezervari/${comandaId}/stocuri`);
    }

    getSumarRezervari(comenziIds: string[]): Promise<any> {
        const params = new URLSearchParams();
        comenziIds.forEach(id => params.append('ids', id));
        return http.clientComercial.get(`PRO_Rezervari/sumar?${params}`);
    }

    rezervaToate(comandaId: string): Promise<any> {
        return http.clientComercial.post(`PRO_Rezervari/${comandaId}/rezerva-toate`);
    }

    rezervaLinie(comandaId: string, liniiId: string, cantitate: number): Promise<any> {
        return http.clientComercial.post(`PRO_Rezervari/${comandaId}/rezerva-linie`, { LinieId: liniiId, Cantitate: cantitate });
    }

    anuleazaRezervari(comandaId: string): Promise<any> {
        return http.clientComercial.delete(`PRO_Rezervari/${comandaId}/rezervari`);
    }

    duplicaComanda(id: string, pastrazaLinkPO: boolean): Promise<any> {
        return http.clientComercial.post(`PRO_Comenzi/${id}/duplica`, { PastreazaLinkPO: pastrazaLinkPO });
    }

    imparteComanda(id: string): Promise<any> {
        return http.clientComercial.post(`PRO_Comenzi/${id}/imparte`);
    }

    genereazaStorno(id: string, liniiIds?: string[]): Promise<any> {
        return http.clientComercial.post(`PRO_Comenzi/${id}/storno`, { LiniiIds: liniiIds ?? null });
    }

    refreshCurs(comandaId: string): Promise<any> {
        return http.clientComercial.post(`PRO_Comenzi/${comandaId}/refresh-curs`);
    }

    previewRefreshCurs(comandaId: string): Promise<any> {
        return http.clientComercial.get(`PRO_Comenzi/${comandaId}/preview-refresh-curs`);
    }

    getDenumiriProduse(partenerID: string): Promise<any> {
        return http.clientComercialOdata.get('PAR_DenumiriProduse', {
            params: { '$filter': `PartenerID eq ${partenerID}` },
        });
    }

    saveDenumire(data: { PartenerID: string; ProdusID: string; Cod?: string; Nume?: string }): Promise<any> {
        return http.clientComercialOdata.post('PAR_DenumiriProduse', data);
    }

    updateDenumire(id: string, data: { Cod?: string; Nume?: string }): Promise<any> {
        return http.clientComercialOdata.patch(`PAR_DenumiriProduse(${id})`, data);
    }

    deleteDenumire(id: string): Promise<any> {
        return http.clientComercialOdata.delete(`PAR_DenumiriProduse(${id})`);
    }

    getPOuriByComanda(comandaId: string): Promise<any> {
        return http.clientComercialOdata.get('PRO_Comenzi', {
            params: {
                '$filter': `ComandaSursaId eq ${comandaId}`,
                '$expand': 'Client($select=Nume),Valuta($select=Simbol)',
                '$select': 'Id,Cod,Stare,DataComenzii,TotalComanda,ValutaId,ClientId,Tipcomanda',
            },
        });
    }

    adaugaEsalonare(data: { ComandaDetaliuID: string; [key: string]: any }): Promise<any> {
        return http.clientComercialOdata.post('PRO_ComenziEsalonari', data);
    }

    patchEsalonare(id: string, data: Record<string, any>): Promise<any> {
        return http.clientComercialOdata.patch(`PRO_ComenziEsalonari(${id})`, data);
    }

    stergeEsalonare(id: string): Promise<any> {
        return http.clientComercialOdata.delete(`PRO_ComenziEsalonari(${id})`);
    }

    getSituatieComenzi(dataStart: string, dataEnd: string, clientId?: string, agentId?: string, stare?: string): Promise<any> {
        const params = new URLSearchParams({ dataStart, dataEnd });
        if (clientId) params.append('clientId', clientId);
        if (agentId) params.append('agentId', agentId);
        if (stare) params.append('stare', stare);
        return http.clientComercial.get(`/PRO_RapoarteComenzi/GetSituatie?${params}`);
    }

    getNelivrate(dataStart: string, dataEnd: string, clientId?: string, agentId?: string): Promise<any> {
        const params = new URLSearchParams({ dataStart, dataEnd });
        if (clientId) params.append('clientId', clientId);
        if (agentId) params.append('agentId', agentId);
        return http.clientComercial.get(`/PRO_RapoarteComenzi/GetNelivrate?${params}`);
    }

    getEsalonariRaport(dataStart: string, dataEnd: string, clientId?: string, agentId?: string, status?: number): Promise<any> {
        const params = new URLSearchParams({ dataStart, dataEnd });
        if (clientId) params.append('clientId', clientId);
        if (agentId) params.append('agentId', agentId);
        if (status != null) params.append('status', String(status));
        return http.clientComercial.get(`/PRO_RapoarteComenzi/GetEsalonari?${params}`);
    }

    getFacturiVsAvize(dataStart: string, dataEnd: string, clientId?: string, agentId?: string): Promise<any> {
        const params = new URLSearchParams({ dataStart, dataEnd });
        if (clientId) params.append('clientId', clientId);
        if (agentId) params.append('agentId', agentId);
        return http.clientComercial.get(`/PRO_RapoarteComenzi/GetFacturiVsAvize?${params}`);
    }

    getRestante(dataStart: string, dataEnd: string, clientId?: string, agentId?: string): Promise<any> {
        const params = new URLSearchParams({ dataStart, dataEnd });
        if (clientId) params.append('clientId', clientId);
        if (agentId) params.append('agentId', agentId);
        return http.clientComercial.get(`/PRO_RapoarteComenzi/GetRestante?${params}`);
    }

    getReceptiiRaport(dataStart: string, dataEnd: string, furnizorId?: string, agentId?: string): Promise<any> {
        const params = new URLSearchParams({ dataStart, dataEnd });
        if (furnizorId) params.append('furnizorId', furnizorId);
        if (agentId) params.append('agentId', agentId);
        return http.clientComercial.get(`/PRO_RapoarteComenzi/GetReceptii?${params}`);
    }

    getDrepturiMele(): Promise<any> {
        return http.clientComercial.get('/PRO_Comenzi/drepturi-mele');
    }

    getCategoriiPermise(): Promise<any> {
        return http.clientComercial.get('/PRO_CategoriiComenzi/permise-mele');
    }

    getTipuriFacturaPermise(): Promise<any> {
        return http.clientComercial.get('/PRO_Comenzi/tipuri-factura-permise');
    }

    updateCategorieComanda(id: string, data: any): Promise<any> {
        return http.clientComercial.patch(`/PRO_CategoriiComenzi/${id}`, data);
    }

    genereazaComenziFurnizori(surseId: string, data: any): Promise<any> {
        return http.clientComercial.post(`/PRO_Comenzi/${surseId}/genereaza-furnizori`, data);
    }

    genereazaAviz(comandaId: string, data: {
        Data?: Date | string | null;
        GestiuneId?: string | null;
        ExpediereNume?: string | null;
        ExpediereMijloc?: string | null;
        Observatii?: string | null;
    }): Promise<any> {
        return http.clientComercial.post(`/PRO_Comenzi/${comandaId}/genereaza-aviz`, data);
    }

    getAvize(comandaId: string): Promise<any> {
        return http.clientComercial.get(`/PRO_Comenzi/${comandaId}/avize`);
    }

    anuleazaAviz(comandaId: string, avizId: string): Promise<any> {
        return http.clientComercial.post(`/PRO_Comenzi/${comandaId}/avize/${avizId}/anuleaza`, {});
    }

    getRezervari(comandaId: string): Promise<any> {
        return http.clientComercial.get(`/PRO_Comenzi/${comandaId}/rezervari`);
    }

    genereazaReceptie(comandaId: string, data: {
        Data?: Date | string | null;
        GestiuneId?: string | null;
        Observatii?: string | null;
        Linii: { LinieId: string; CantitateReceptionata: number; PretAchizitie?: number | null }[];
    }): Promise<any> {
        return http.clientComercial.post(`/PRO_Comenzi/${comandaId}/receptie`, data);
    }

    getReceptii(comandaId: string): Promise<any> {
        return http.clientComercial.get(`/PRO_Comenzi/${comandaId}/receptii`);
    }

    getCantitatiReceptionate(comandaId: string): Promise<any> {
        return http.clientComercial.get(`/PRO_Comenzi/${comandaId}/cantitati-receptionata`);
    }

    calculaLinie(data: { Cantitate?: number | null; PretUnitar?: number | null; TVA?: number | null; DiscountProc?: number | null; PretLista?: number | null; PretListaCurs?: number | null; PretListaValutaID?: string | null; PretUnitarEditatManual?: boolean }): Promise<any> {
        return http.clientComercial.post('PRO_ComenziDetalii/calcola', data);
    }

    genereazaFactura(comandaId: string, data: {
        Data?: Date | string | null;
        Scadenta?: Date | string | null;
        AvizId?: string | null;
        Observatii?: string | null;
    }): Promise<any> {
        return http.clientComercial.post(`/PRO_Comenzi/${comandaId}/genereaza-factura`, data);
    }

    getFacturi(comandaId: string): Promise<any> {
        return http.clientComercial.get(`/PRO_Comenzi/${comandaId}/facturi`);
    }

    getDocumenteGenerate(comandaId: string): Promise<any> {
        return http.clientComercial.get(`/PRO_Comenzi/${comandaId}/documente`);
    }

    getComenziStorno(comandaId: string): Promise<any> {
        return http.clientComercial.get(`/PRO_Comenzi/${comandaId}/storno-uri`);
    }

    storneazaFactura(comandaId: string, facturaId: string, motiv?: string): Promise<any> {
        return http.clientComercial.post(`/PRO_Comenzi/${comandaId}/facturi/${facturaId}/storneaza`, { Motiv: motiv ?? null });
    }

    anuleazaFactura(comandaId: string, facturaId: string): Promise<any> {
        return http.clientComercial.post(`/PRO_Comenzi/${comandaId}/facturi/${facturaId}/anuleaza`, {});
    }
}

export default new ProComenziDataService();